module.exports = __webpack_public_path__ + "static/img/5.1c87b10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/sp/5.png
// module id = o8iD
// module chunks = 0